// extracted by mini-css-extract-plugin
export default {"Role":"ConcessionOrganizationRoles_Role__2CT9m"};